import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import {
  isSupportBannerForced,
  subscribeSupportApiBanner,
} from '../utils/supportApiErrorNotifier';

const SupportApiErrorContext = createContext(null);

export function SupportApiErrorProvider({ children }) {
  const [serverErrorBanner, setServerErrorBanner] = useState(() => isSupportBannerForced());

  useEffect(() => {
    return subscribeSupportApiBanner(() => setServerErrorBanner(true));
  }, []);

  const clearBanner = useCallback(() => {
    if (!isSupportBannerForced()) {
      setServerErrorBanner(false);
    }
  }, []);

  const value = useMemo(
    () => ({
      showSupportBanner: serverErrorBanner,
      clearSupportBanner: clearBanner,
    }),
    [serverErrorBanner, clearBanner]
  );

  return (
    <SupportApiErrorContext.Provider value={value}>{children}</SupportApiErrorContext.Provider>
  );
}

export function useSupportApiError() {
  const ctx = useContext(SupportApiErrorContext);
  if (!ctx) {
    throw new Error('useSupportApiError debe usarse dentro de SupportApiErrorProvider');
  }
  return ctx;
}
